<template>
  <div class="evaluat_user-root tea_eval_show-root">
    <div class="avator">
      <img class="img" :src="isImgLoadErr ? $options._myOpt.chinaAssImg:orgInfo.profile_picture" @error="isImgLoadErr = true">
    </div>
    <div class="info">
      <p>
        <span>{{orgInfo.name}}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>注册时间：{{orgInfo.create_time | time(false)}}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>状态：{{orgInfo.status | transStatus}}</span>
      </p>
      <p>
        <span>管理员姓名：{{orgInfo.user_name}}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>电话：{{orgInfo.tel_number||"--"}}</span>
      </p>
      <p>
        <span>城市：{{orgInfo.provice_name}}{{orgInfo.city_name}}{{orgInfo.county_name}}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span>详细地址：{{orgInfo.user_address||"--"}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import chinaAssImg from "@/assets/images/org_logo.png";
import {userStatus} from '@/assets/js/status'
export default {
  name: "TeaEvaluatUser",
  _myOpt: {
    chinaAssImg,
  },
  props: {
    orgInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isImgLoadErr: false
    }
  },
  filters: {
    transStatus(statu) {
      return userStatus(statu)
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluatUserShow'

</style>
